import { render, staticRenderFns } from "./question-banner.vue?vue&type=template&id=6bb272de&scoped=true"
import script from "./question-banner.vue?vue&type=script&lang=ts"
export * from "./question-banner.vue?vue&type=script&lang=ts"
import style0 from "./question-banner.vue?vue&type=style&index=0&id=6bb272de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb272de",
  null
  
)

export default component.exports